export const DEFAULT_NAV_LINKS = {
  dashboard: '/customer/dashboard',
  community: '/customer/community',
  leaderboard: '/customer/leaderboard',
  calendar: '/customer/calendar'
}
